import * as React from "react";
import { useLazyQuery } from "@grandvisionhq/graphql";
import { GET_CONTACT_LENS_BY_PRESCRIPTION } from "../../../../../../../operations/queries/modules/EcommContent/ContactLensesEcommContent/operations/queries/get-contact-lens-by-prescription.js";
import { mapServerToClientPrescriptionCLProduct } from "../../../../../mappers/server-to-client/modules/EcommContent/ContactLensesEcommContent/hooks/api/mappers/server-to-client/map-to-client-prescription-contact-lens-product.js";
import { RECOVERABLE_ERROR, CANNOT_EXECUTE_QUERY } from "../../../../../../../../../../types/types/generic-query-errors.js";
const useGetCLByPrescription = ({
  onSuccess,
  onError
}) => {
  const [query] = useLazyQuery(GET_CONTACT_LENS_BY_PRESCRIPTION, {
    fetchPolicy: "no-cache",
    onCompleted(result) {
      const mappedResult = mapServerToClientPrescriptionCLProduct(result);
      if (mappedResult.type === "SUCCESS") {
        onSuccess(mappedResult);
      } else {
        onError?.({ error: mappedResult.error });
      }
    },
    onError() {
      onError?.({ error: RECOVERABLE_ERROR });
    }
  });
  const getCLByPrescription = React.useCallback(
    (variables, activeSku) => {
      if (variables.masterVariantSku === "") {
        console.error(
          `Cannot call getCLByPrescription for Contact Lens product with sku: ${activeSku} because the masterVariantSku is invalid.`
        );
        return onError?.({ error: CANNOT_EXECUTE_QUERY });
      } else {
        query({ variables });
      }
    },
    [onError, query]
  );
  return React.useMemo(() => getCLByPrescription, [getCLByPrescription]);
};
export {
  useGetCLByPrescription
};
//# sourceMappingURL=use-get-cl-by-prescription.js.map
